export default {
  confirm: '确认',
  cancel: '取消',
  save: '保存',
  noSave: '不保存',
  delete: '删除',
  edit: '编辑',
  add: '新增',
  search: '搜索',
  reset: '重置',
  back: '返回',
  submit: '提交',
  loading: '加载中...',
  noData: '暂无数据',
  noMoreData: '没有数据了',
  success: '操作成功',
  failed: '操作失败',
  required: '此项为必填项',
  development: '开发中',
  underConstruction: '功能建设中',
  all: '全部',
  operation: '操作',
  pleaseInputLanguage: '请输入语言',
  pleaseSelect: '请选择',
  pleaseInput: '请输入',
  upload: '上传',
  uploadVideo: '上传视频',
  uploadImage: '上传图片',
  previousStep: '上一步',
  nextStep: '下一步',
  sort: '排序',
  multilingual: '多语言',
  languageVersion: '语言版本',
  select: '选择',
  total: '共',
  item: '条',
  updatedAt: '更新时间',
  current: '当前',
  switch: '切换',
  copy: '复制',
  pleaseEnter: '请输入',
  comingSoon: '功能开发中',
  home: '首页',
  action: '操作',
  warning: '警告',
  logout: '退出登录',
  logoutConfirm: '确认退出',
  logoutConfirmContent: '确定要退出登录吗？',
  user: '用户',
  adminTitle: '后台管理',
  selectField: '选择字段',
  none: '无',
  copySuccess: '复制成功',
};
